// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6n-4";
export var collapsed = "_6n-1";
export var headerBar = "_6n-0";
export var leftHeaderContent = "_6n-3";
export var subjectContainer = "_6n-2";